import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// Bootstrap components
import Container from "react-bootstrap/Container";
// Custom components
import Counter from "../components/Counter/Counter";
import ServicesCard from "../components/ServicesCard/ServicesCard";
import CustomNav from "../components/CustomNav/CustomNav";
// API
import { getHome } from "../api/home";
// Custom styles
import "../scss/pages/home.styles.scss";
// Assets
import bulletFigure from "../assets/images/symbol.svg";
import checkList from "../assets/images/afix-perks.jpeg";
import checkIcon from "../assets/images/check-icon.svg";
import phoneWhite from "../assets/images/phone--white.svg";
import emailWhite from "../assets/images/email--white.svg";
import videoFondo from "../assets/videos/hero-video.mp4";

import imgTab01 from "../assets/images/servicios-tab-01.jpg";
import imgTab02 from "../assets/images/servicios-tab-02.jpg";
import imgTab03 from "../assets/images/servicios-tab-03.jpg";
import imgTab04 from "../assets/images/servicios-tab-04.jpg";

import iconTab01 from "../assets/images/tab-icon-01.png";
import iconTab02 from "../assets/images/tab-icon-02.png";
import iconTab03 from "../assets/images/tab-icon-03.png";
import iconTab04 from "../assets/images/tab-icon-04.png";
import imgCrecimiento from "../assets/images/impulsamos-tu-crecimiento-home.png";

import iconPerks01 from "../assets/images/perks-icon-01.png";
import iconPerks02 from "../assets/images/perks-icon-02.png";
import iconPerks03 from "../assets/images/perks-icon-03.png";
import iconPerks04 from "../assets/images/perks-icon-04.png";
const iconsList = [iconPerks01, iconPerks02, iconPerks03, iconPerks04];

        function Home() {
        const [loading, setLoading] = useState(false);
                const [homeData, sethomeData] = useState({});
                const [activeTab, setActiveTab] = useState(0);
                useEffect(() => {
                const fetchData = async () => {
                try {
                setLoading(true);
                        const { response, result } = await getHome();
                        if (response.status === 304) {
                sethomeData(result.docs[0]);
                } else if (!response.ok) {
                console.error("Error fetching home :", response.ok);
                } else {
                sethomeData(result.docs[0]);
                }
                } catch (error) {
                console.error("Error fetching  data", error);
                } finally {
                setLoading(false);
                }
                };
                        fetchData();
                }, []);
                if (
                        loading &&
                        Object.keys(homeData).length === 0 &&
                        homeData.constructor === Object
                        ) {
        return (
                <Container style={{ marginTop: "90px" }}>
  <h6 className="text-center py-3">Cargando información...</h6>
</Container>
                );
        } else {
        return (
                <>
<CustomNav transparent={true} disp={true} />

<section className="hero__main">
  <video autoPlay loop muted playsInline className="hero__video-bg">
    <source src={videoFondo} type="video/mp4" />
    Tu navegador no soporta video en HTML5.
  </video>
</section>

<section className="about__home__wrapper">
  <div className="container">
    <div className="row">
      <div className="col-12 col-lg-6">
        <h6 className="mb-4"><span>Nosotros tenemos<br/> la </span> mejor solución para ti.</h6>

        {homeData?.aboutDescription?.length >= 1 ? (
                        homeData?.aboutDescription?.map((description, key) => (
                                <p key={{ key }} className="mb-2">
          {description?.children[0]?.text}
        </p>
                                ))
                        ) : (
                <p>null</p>
                )}
      </div>
      <div className="col-12 col-lg-6 d-flex justify-content-center"
           >
           <div className="filas_contador">
          {homeData?.stats?.map((stat, key) => (
                <div key={key} className={`filas item_fila${key}`}>
            <Counter finalValue={stat.individualStatistic}>
              <span>+</span>
            </Counter>

            <p>{stat.caption}</p>
          </div>
                ))}
        </div>
      </div>
    </div>
  </div>
</section>

<section className="services-section">
  <div className="container">
    <h2 className="services-title">Servicios financieros</h2>
    <p className="services-subtitle">
      Conoce las <strong>herramientas financieras</strong> con las que estructuramos la <strong>solución a la medida:</strong>
    </p>

    {/* --- NAVEGACIÓN DE TABS --- */}
    <div className="services-tabs">
      {/* Tab 1 */}
      <button 
          className={`tab-btn ${activeTab === 0 ? 'active' : ''}`} 
          onClick={() => setActiveTab(0)}
          >
        <div className="icon-circle">
          <img src={iconTab01} alt="" className="" />
        </div>
        <span className="tab-label">Crédito simple:</span>
      </button>

      {/* Tab 2 */}
      <button 
          className={`tab-btn ${activeTab === 1 ? 'active' : ''}`} 
          onClick={() => setActiveTab(1)}
          >
        <div className="icon-circle">
          <img src={iconTab02} alt="" className="" />
        </div>
        <span className="tab-label">Crédito cuenta corriente:</span>
      </button>

      {/* Tab 3 */}
      <button 
          className={`tab-btn ${activeTab === 2 ? 'active' : ''}`} 
          onClick={() => setActiveTab(2)}
          >
        <div className="icon-circle">
          <img src={iconTab03} alt="" className="" />
        </div>
        <span className="tab-label">Arrendamiento:</span>
      </button>
      <button 
          className={`tab-btn ${activeTab === 3 ? 'active' : ''}`} 
          onClick={() => setActiveTab(3)}
          >
        <div className="icon-circle">
          <img src={iconTab04} alt="" className="" />
        </div>
        <span className="tab-label">Crédito Simple Sin Garantía:</span>
      </button>
    </div>

    {/* --- TABS --- */}
    <div className="services-content">
      <div className="row align-items-center">

        {/* Columna de Texto */}
        <div className="col-12 col-lg-12">
          {activeTab === 0 && (
                <div className="fade-in">
            <div className="row">
              <div className="col-12 col-lg-5 text-column">
                <p>Obtén <strong>flexibilidad y tranquilidad</strong> con nuestra herramienta de crédito. Financia inversiones, capital de trabajo, liquidez y otros objetivos comerciales. Ofrecemos esquemas de pagos fijos o escalonados, <strong>adaptados al tamaño y giro de tu empresa</strong>.</p>
              </div>
              <div className="col-12 col-lg-7 image-column">
                <div className="image-wrapper">
                  <img src={imgTab01} alt="Servicio Financiero" className="main-img" />
                </div>
              </div>
            </div>
          </div>
                )}
          {activeTab === 1 && (
                <div className="fade-in">
            <div className="row">
              <div className="col-12 col-lg-5 text-column">
                <p>Mejora la <strong>gestión financiera y optimiza el flujo de tu empresa</strong> con nuestra línea de crédito. Accede de manera flexible a fondos según tus necesidades financieras. Ofrecemos esquemas de pagos adecuados y <strong>disponibilidad de recursos inmediata</strong>.</p>
              </div>
              <div className="col-12 col-lg-7 image-column">
                <div className="image-wrapper">
                  <img src={imgTab02} alt="Servicio Financiero" className="main-img" />
                </div>
              </div>
            </div>
          </div>
                )}
          {activeTab === 2 && (
                <div className="fade-in">
            <div className="row">
              <div className="col-12 col-lg-5 text-column">
                <p>Obtén los <strong>activos comerciales que necesitas</strong> sin comprometer tu capital. Adquiere <strong>equipo especializado, maquinaria</strong> u otros activos esenciales para tu operación. Ofrecemos flexibilidad de elección y plazos, así como <strong>opciones de compra al final del periodo</strong>. Optimiza tu flujo de efectivo y mantente actualizado con las últimas tecnologías y equipos, sin grandes inversiones iniciales.</p>
              </div>
              <div className="col-12 col-lg-7 image-column">
                <div className="image-wrapper">
                  <img src={imgTab03} alt="Servicio Financiero" className="main-img" />
                </div>
              </div>
            </div>
          </div>
                )}
          {activeTab === 3 && (
                <div className="fade-in">
            <div className="row">
              <div className="col-12 col-lg-5 text-column">
                <p>
                    Producto exclusivo para <strong>PyMEs del Estado de Jalisco.</strong> Obtén hasta $1,500,000 pesos para capital de trabajo sin necesidad de presentar garantías inmobiliarias. Ofrecemos plazos de hasta 48 meses y sin penalización por pago anticipado. Necesitas buen historial crediticio, al menos <strong>2 años de operación, opinión de cumplimiento positiva y un aval</strong> que exhiba propiedades (no se gravan).
                </p>
              </div>
              <div className="col-12 col-lg-7 image-column">
                <div className="image-wrapper">
                  <img src={imgTab04} alt="Servicio Financiero" className="main-img" />
                </div>
              </div>
            </div>
          </div>
                )}
        </div>
      </div>
    </div>
    {/* --- TABS --- */} 
  </div>
</section>


<section className="information">
  <div className="container">
    <div className="information__row">
      <div className="information__row__body">
        <h2 className="information__row__body__title">
          {homeData?.marketsTitle}
        </h2>
        {homeData?.marketsDescription?.length >= 1 ? (
                homeData?.marketsDescription?.map((description, key) => (
                        <p
            className="information__row__body__text"
            key={{ key }}
            style={
                        description.children[0].italic
                        ? { fontStyle: "italic" }
                : { fontStyle: "unset" }
                      }
            >
          {description.children[0].text}
        </p>
                        ))
                ) : (
                <p
            className="information__row__body__text"
            // style={
                //   homeData?.marketsDescription?.children[0]?.italic === true
                //     ? { fontStyle: "italic" }
                //     : { fontStyle: "unset" }
                // }
                // style={description.children[0].italic ? fontStyle : "italic"}
                >
        {/* {homeData?.marketsDescription[0]?.children[0]?.text} */}
        Sin texto
                < /p>
                )}

            <Link className="information__row__body__button" to="/mercados">
          {" "}
          Saber más
          </Link>
      </div>

                </div>
                </div>
                </section>


<section className="perks_home__wrapper">
  <div className="perks_home__container">
    <div className="container">
      <div className="row align-items-center">
        
        <div className="col-12 col-lg-8">
          <div className="perks_home__container__content">
            <h4>{homeData?.perksTitle || "Impulsamos tu crecimiento"}</h4>
            <div className="description-box">
               {homeData?.perksDescription?.length >= 1 ? (
                  homeData?.perksDescription?.map((description, key) => (
                    <p key={key}>
                      {description.children[0].text}
                    </p>
                  ))
                ) : (
                  <p>En AFIX, estamos para ayudarte a alcanzar tus objetivos...</p>
                )}
            </div>

            <div className="perks_home__container__content__list">
              {homeData?.perksPills?.map((perkPill, key) => (
                <div key={key} className="perks_home__container__content__list__pill">
                  <div className="icon-wrapper">
                    <img 
                        src={iconsList[key % iconsList.length]} 
                        alt={perkPill.pillTitle} 
                        className="img-fluid"
                    />
                    
                  </div>
                  <h6>{perkPill.pillTitle}</h6>
                </div>
              ))}
            </div>

          </div>
        </div>

        <div className="col-12 col-lg-5">
          <div className="perks_home__container__media text-end">
            <img
              src={imgCrecimiento}
              alt="Crecimiento"
              className="img-fluid main-image"
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</section>


                <section className="contact">
  <div className="container">
    <h2 className="contact__title text-center">
      <div className="row justify-content-center">
      <div className="col-12 col-lg-12">
       <h2>Somos el aliado financiero para lograr tu crecimiento,</h2>
       <h3>Solicita cualquiera de <span>nuestros créditos.</span></h3>


           <div className="contact__row">
      <div className="contact__row__link">
        <div className="contact__row__link__button">
          <div className="contact__row__link__button__row">
            <h5 className="contact__row__link__button__row__title">
              Habla con un asesor:
            </h5>
            <a
                href="tel:+523336301888"
                className="contact__row__link__button__row__title"
                >
              (33)-36-30-18-88
            </a>
          </div>
        </div>
      </div>

      <div className="contact__row__link">
        <div className="contact__row__link__button">
          <div className="contact__row__link__button__row">
            <h5 className="contact__row__link__button__row__title">
              Manda tu solicitud a:
            </h5>
            <a
                href="mailto:hola@afix.com.mx"
                className="contact__row__link__button__row__title"
                >
              hola@afix.com.mx
            </a>
          </div>
        </div>
      </div>
    </div>
    
      </div>
      </div>
    </h2>


  </div>
</section>
                </>
                );
}
}

export default Home;
